import { PressableNeolexon } from '@/components/PressableNeolexon';
import { Text } from '@/components/Text';
import { useEffect, useState } from 'react';
import { Image, View } from 'react-native';
import AVATAR from '@/assets/avatars';
import { styles } from './styles';

type Avatar = {
  url: string;
  name: string;
};

type AvatarListProps = {
  onAvatarPress: (avatar: string) => void;
  defaultAvatar?: string;
};

const avatarList: Avatar[] = [
  {
    url: 'modules/patients/client/img/avatar/avatar1.png',
    name: 'avatar1',
  },
  {
    url: 'modules/patients/client/img/avatar/avatar2.png',
    name: 'avatar2',
  },
  {
    url: 'modules/patients/client/img/avatar/avatar3.png',
    name: 'avatar3',
  },
  {
    url: 'modules/patients/client/img/avatar/avatar4.png',
    name: 'avatar4',
  },
  {
    url: 'modules/patients/client/img/avatar/avatar5.png',
    name: 'avatar5',
  },
  {
    url: 'modules/patients/client/img/avatar/avatar6.png',
    name: 'avatar6',
  },

  {
    url: 'modules/patients/client/img/avatar/avatar7.png',
    name: 'avatar7',
  },
  {
    url: 'modules/patients/client/img/avatar/avatar8.png',
    name: 'avatar8',
  },
  {
    url: 'modules/patients/client/img/avatar/avatar9.png',
    name: 'avatar9',
  },
  {
    url: 'modules/patients/client/img/avatar/avatar10.png',
    name: 'avatar10',
  },
  {
    url: 'modules/patients/client/img/avatar/avatar11.png',
    name: 'avatar11',
  },
  {
    url: 'modules/patients/client/img/avatar/avatar12.png',
    name: 'avatar12',
  },
];

export const AvatarList = ({
  onAvatarPress,
  defaultAvatar,
}: AvatarListProps) => {
  const [checked, setChecked] = useState<number | null>(null);

  const onChecked = (index: number, avatar: string) => {
    setChecked(index);
    onAvatarPress(avatar);
  };

  const getImageNumber = (url: string): number => {
    const imageUrlEnding = url.split('avatar');
    const imageNumber = imageUrlEnding[imageUrlEnding.length - 1].split('.')[0];
    return parseInt(imageNumber);
  };

  useEffect(() => {
    if (defaultAvatar) {
      setChecked(getImageNumber(defaultAvatar));
    }
  }, [defaultAvatar]);

  const getSource = (url: string) => {
    const avatarArray = url.split('/');
    const image = avatarArray[avatarArray.length - 1].split('.')[0];
    return AVATAR[image as keyof typeof AVATAR];
  };

  const selectedAvatar = avatarList.find(
    (item) => getImageNumber(item.url) === checked,
  );

  return (
    <>
      <View>
        <Text style={styles.heading}>Profil anpassen</Text>
        <Text style={styles.description}>
          Zur besseren Unterscheidung Ihrer Patient:innen haben Sie die
          Möglichkeit, eine Farbe als Hintergrund für das Profilbild festzulegen
        </Text>
      </View>

      <View style={styles.content}>
        <View style={styles.selectedAvatarWrapper}>
          <Image
            source={getSource((selectedAvatar ?? avatarList[0]).url)}
            style={styles.selectedAvatar}
            resizeMode="cover"
          />
        </View>

        <View style={styles.picker}>
          {avatarList.map((item, index) => (
            <PressableNeolexon
              key={index}
              onPress={() => {
                onChecked(getImageNumber(item.url), item.url);
              }}
            >
              <Image
                source={getSource(item.url)}
                style={[
                  styles.avatar,
                  getImageNumber(item.url) === checked
                    ? styles.avatarSelected
                    : styles.avatarUnselected,
                ]}
                resizeMode="cover"
              />
            </PressableNeolexon>
          ))}
        </View>
      </View>
    </>
  );
};
